import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import styles from './Home.module.css';
import Destination from './Destination';
import Crew from './Crew';
import Technology from './Technology';
import Home from './Home'
// import './App.css';

const App = () => {
 
  

  return (
    <div>
    <Router basename="/galaxy-landing">
     
        
      
     <Routes>
       <Route index element={<Home />} />
       <Route path="/destination" element={<Destination />} />
       <Route path="/crew" element={<Crew />} />
       <Route path="/technology" element={<Technology />} />
     </Routes>

 </Router>
    </div>

  );
}

export default App;